import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-header-message" }
const _hoisted_2 = { class: "c-common-inner" }
const _hoisted_3 = { class: "p-header-message__body__text" }
const _hoisted_4 = {
  key: 0,
  class: "p-header-message__body__arrow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.url === '' ? `p` : `a`), {
        href: _ctx.url,
        class: "p-header-message__body"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.message), 1),
          (_ctx.url !== '')
            ? (_openBlock(), _createElementBlock("i", _hoisted_4, [
                _createVNode(_component_IconBase, {
                  "view-box": "0 0 24 24",
                  width: "24",
                  height: "24",
                  "icon-color": "#ffffff",
                  class: "p-group-list-panel__bottom__arrow"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconArrowRight)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["href"]))
    ])
  ]))
}